import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import DashboardPage from '../pages/DashboardPage';
import MediaManagerPage from '../pages/MediaManagerPage';
import MapManagerPage from '../pages/MapManagerPage';
import OrganizationManagerPage from '../pages/OrganizationManagerPage';
import MapViewerPage from '../pages/MapViewerPage';
import ProfilePage from '../pages/ProfilePage';
import EntityModelManagerPage from '../pages/EntityModelManagerPage';
import MonitorGroupsPage from '../pages/MonitorGroupsPage';
import ProtectedRoute from './ProtectedRoute';

const AppRouter = ({ user, onLogin, onLogout }) => {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route
          path="/login"
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <AuthForm onLogin={onLogin} />
            )
          }
        />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute user={user}>
              <DashboardPage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/media"
          element={
            <ProtectedRoute user={user}>
              <MediaManagerPage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/entity-models"
          element={
            <ProtectedRoute user={user}>
              <EntityModelManagerPage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/maps"
          element={
            <ProtectedRoute user={user}>
              <MapManagerPage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/organizations"
          element={
            <ProtectedRoute user={user}>
              <OrganizationManagerPage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute user={user}>
              <ProfilePage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/maps/:id"
          element={
            <ProtectedRoute user={user}>
              <MapViewerPage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/monitor-groups"
          element={
            <ProtectedRoute user={user}>
              <MonitorGroupsPage user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        />

        {/* Default redirects */}
        <Route
          path="/"
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Catch all - redirect to appropriate landing */}
        <Route
          path="*"
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;
